module.exports = __webpack_public_path__ + "img/telegram.69cd77ea.png";